import React from 'react';
import { useTranslation } from 'react-i18next';

import emptyState from 'public/empty-state-account.png';
import { Center, Text, Image, VStack } from 'quotient';

type Props = {};

const NotFound: React.VFC<Props> = () => {
  const { t } = useTranslation();

  return (
    <Center p={4} w="100%">
      <VStack alignItems="center" gap={8}>
        <Image alt="Set Account Data" maxWidth="xs" src={emptyState} />
        <Text textStyle="headingLarge">{t('Errors.page_not_found')}</Text>
      </VStack>
    </Center>
  );
};
export default NotFound;
